import { z } from "zod";

export const supplierAdminContactValidator = z.object({
  name: z.string().min(2, { error: "A name is required" }),
  email: z.union([z.email(), z.literal("")]).nullish(),
  phone: z.string().nullish(),
  role: z.string().nullish(),
  description: z.string().nullish(),
});
